var _desc, _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "65px",
    viewBox: "0 0 67 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tertiary-finance-survey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "48.2351515%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.062500,1.000000),rotate(90.000000),scale(1.000000,16.542268),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.9155431%",
    cy: "50.9384395%",
    fx: "48.9155431%",
    fy: "50.9384395%",
    r: "48.2351515%",
    gradientTransform: "translate(0.489155,0.509384),scale(0.093750,1.000000),rotate(90.000000),scale(1.000000,10.390143),translate(-0.489155,-0.509384)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.1807637%",
    y1: "83.7378561%",
    x2: "19.8675264%",
    y2: "4.632213%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 28,
    cy: 28,
    r: 22.5806452
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-2.2%",
    width: "104.4%",
    height: "104.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.97254902   0 0 0 0 0.97254902   0 0 0 0 0.97254902  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 28,
    cy: 28,
    r: 22.5806452
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.2%",
    y: "-2.2%",
    width: "104.4%",
    height: "104.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.5268297%",
    y1: "8.66166063%",
    x2: "92.7056207%",
    y2: "94.462755%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0.0712626689%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.15,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.511944085,0.0218847495 L31.4993005,0.000347994909 C31.7754428,0.000156071176 31.999456,0.223858057 31.9996479,0.500000365 C31.999648,0.50023341 31.999648,0.500466454 31.9996479,0.500699499 L31.9877083,17.478467 C31.9875143,17.7543363 31.7639252,17.9779235 31.4880559,17.9781153 L0.500699502,17.999652 C0.224557193,17.9998439 0.000544037368,17.7761419 0.000352113635,17.4999996 C0.000351951665,17.4997666 0.000351952624,17.4995335 0.000352116513,17.4993005 L0.0122917176,0.521533004 C0.0124857225,0.245663686 0.236074766,0.0220764835 0.511944085,0.0218847495 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-42.8%",
    width: "181.2%",
    height: "259.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.368599741,0.0157570196 L22.6794964,0.000250556334 C22.8783188,0.000112371247 23.0396083,0.161177801 23.0397465,0.360000263 C23.0397466,0.360168055 23.0397466,0.360335847 23.0397465,0.360503639 L23.03115,12.5844962 C23.0310103,12.7831221 22.8700262,12.9441049 22.6714003,12.944243 L0.360503641,12.9597494 C0.161681179,12.9598876 0.000391706905,12.7988222 0.000253521817,12.5999997 C0.000253405199,12.5998319 0.00025340589,12.5996642 0.000253523889,12.5994964 L0.00885003668,0.375503763 C0.00898972019,0.176877854 0.169973832,0.0158950681 0.368599741,0.0157570196 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-39.1%",
    y: "-34.7%",
    width: "160.8%",
    height: "227.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Employee-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-First-Use-LG-03.0.0",
    transform: "translate(-956.000000, -413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracker",
    transform: "translate(62.000000, 222.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(863.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-tertiary-finance-survey",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shadow-large",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-1)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 2,
    rx: 32,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow",
    fill: "url(#radialGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    cx: 32,
    cy: 1.5,
    rx: 16,
    ry: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin",
    strokeWidth: 1,
    transform: "translate(32.000000, 34.000000) rotate(-360.000000) translate(-32.000000, -34.000000) translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    transform: "translate(27.895522, 28.000000) rotate(-360.000000) translate(-27.895522, -28.000000) ",
    cx: 27.8955224,
    cy: 28,
    rx: 27.8955224,
    ry: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.65,
    transform: "translate(28.000000, 28.000000) rotate(-360.000000) translate(-28.000000, -28.000000) ",
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.5,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "url(#linearGradient-8)",
    strokeWidth: 1.35343035,
    opacity: 0.5,
    cx: 28,
    cy: 28,
    r: 27.3232848
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1290323,21.7737933 C36.1290323,23.6026575 35.5194109,24.8936204 33.6188265,26.5073241 L30.75002,28.9458097 C29.3873369,30.0933323 29.2080365,30.6670936 29.2080365,31.8863363 L29.2080365,33.1772993 L27.5226127,33.1772993 C26.4468102,33.1772993 25.3351477,32.2449372 25.3351477,31.0615545 C25.3351477,29.3044105 25.908909,27.9775874 27.666053,26.5431842 L30.2121188,24.4632994 C31.0369007,23.7819579 31.2879212,23.0288962 31.2879212,22.3116945 C31.2879212,20.5904106 30.1045385,19.6221884 27.7019131,19.6221884 C24.9765469,19.6221884 22.9683823,20.5186905 21.8567198,22.0248139 L21.6774194,22.0248139 L21.6774194,20.3393901 C21.6774194,17.9009045 23.7573041,15.3548387 28.4549748,15.3548387 C33.4395261,15.3548387 36.1290323,18.2953654 36.1290323,21.7737933 Z M31.0369007,37.6598095 C31.0369007,39.3452333 29.6383575,40.7437765 27.9529336,40.7437765 C26.2675098,40.7437765 24.8689666,39.3452333 24.8689666,37.6598095 C24.8689666,35.9743857 26.2675098,34.5758425 27.9529336,34.5758425 C29.6383575,34.5758425 31.0369007,35.9743857 31.0369007,37.6598095 Z",
    id: "?",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "note",
    strokeWidth: 1,
    transform: "translate(18.000000, 15.000000) rotate(-24.000000) translate(-18.000000, -15.000000) translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EBB9",
    strokeWidth: 1.39083341,
    d: "M0.707571018,0.71716566 L0.695906271,17.3040995 L31.292429,17.2828343 L31.3040937,0.695900542 L0.707571018,0.71716566 Z",
    strokeLinejoin: "square",
    fill: "url(#linearGradient-9)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F8F8F8",
    strokeWidth: 1.39083341,
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L1,5 C3.209139,5 5,3.209139 5,1 C3.80609267,1 2.47275933,1 1,1 Z",
    id: "Oval",
    fill: "#62EBB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,13 L1,17 C3.209139,17 5,15.209139 5,13 C3.80609267,13 2.47275933,13 1,13 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(3.000000, 15.000000) scale(1, -1) translate(-3.000000, -15.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,1 L27,5 C29.209139,5 31,3.209139 31,1 C29.8060927,1 28.4727593,1 27,1 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(29.000000, 3.000000) scale(-1, 1) translate(-29.000000, -3.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,13 L27,17 C29.209139,17 31,15.209139 31,13 C29.8060927,13 28.4727593,13 27,13 Z",
    id: "Oval",
    fill: "#62EBB9",
    transform: "translate(29.000000, 15.000000) scale(-1, -1) translate(-29.000000, -15.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 16,
    cy: 9,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 27,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#62EBB9",
    cx: 5,
    cy: 9,
    r: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "note",
    strokeWidth: 1,
    transform: "translate(52.000000, 43.500000) rotate(-330.000000) translate(-52.000000, -43.500000) translate(40.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2CB5D6",
    strokeWidth: 1.00140006,
    d: "M0.509451133,0.516359276 L0.501052515,12.4589516 L22.5305489,12.4436407 L22.5389475,0.50104839 L0.509451133,0.516359276 Z",
    strokeLinejoin: "square",
    fill: "url(#linearGradient-12)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F8F8F8",
    strokeWidth: 1.00140006,
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.72,0.72 L0.72,3.6 C2.31058008,3.6 3.6,2.31058008 3.6,0.72 C2.74038672,0.72 1.78038672,0.72 0.72,0.72 Z",
    id: "Oval",
    fill: "#2CB5D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72,9.36 L0.72,12.24 C2.31058008,12.24 3.6,10.9505801 3.6,9.36 C2.74038672,9.36 1.78038672,9.36 0.72,9.36 Z",
    id: "Oval",
    fill: "#2CB5D6",
    transform: "translate(2.160000, 10.800000) scale(1, -1) translate(-2.160000, -10.800000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.44,0.72 L19.44,3.6 C21.0305801,3.6 22.32,2.31058008 22.32,0.72 C21.4603867,0.72 20.5003867,0.72 19.44,0.72 Z",
    id: "Oval",
    fill: "#2CB5D6",
    transform: "translate(20.880000, 2.160000) scale(-1, 1) translate(-20.880000, -2.160000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.44,9.36 L19.44,12.24 C21.0305801,12.24 22.32,10.9505801 22.32,9.36 C21.4603867,9.36 20.5003867,9.36 19.44,9.36 Z",
    id: "Oval",
    fill: "#2CB5D6",
    transform: "translate(20.880000, 10.800000) scale(-1, -1) translate(-20.880000, -10.800000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 11.52,
    cy: 6.48,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 19.44,
    cy: 6.48,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2CB5D6",
    cx: 3.6,
    cy: 6.48,
    r: 1.44
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyQuestionIcon);
export default __webpack_public_path__ + "static/media/money-question-icon.308bdcad205e80b5f43d412ca7a9710e.svg";
export { ForwardRef as ReactComponent };